/*
 * Purpose: Flows layout — sub-nav shell for My flows + Templates
 * Last modified: 2026-07-01 | Agent
 * Completeness: 100
 */
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { PageMotion } from '@/components/motion/PageMotion';
import { FlowsSubNav } from '@/components/flows/FlowsSubNav';
import { APP_ROUTES } from '@/lib/appRoutes';
import { FLOW_TEMPLATES_IA } from '@/lib/flowTemplates';
import { findBuilderNavItem } from '@/lib/productActivities';

export default function FlowsLayout() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const myFlowsLabel = findBuilderNavItem('flows')?.label ?? 'My flows';

  useEffect(() => {
    if (params.get('tab') === 'templates') {
      navigate(APP_ROUTES.flowTemplates, { replace: true });
    }
  }, [params, navigate]);

  const onTemplates = pathname.startsWith(APP_ROUTES.flowTemplates);

  return (
    <PageMotion variant="body">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 sm:py-8 space-y-4 sm:space-y-6 ui-page-hierarchy">
        <div className="space-y-1">
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            {FLOW_TEMPLATES_IA.parentLabel}
          </p>
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground">
            {onTemplates ? FLOW_TEMPLATES_IA.label : myFlowsLabel}
          </h1>
        </div>
        <FlowsSubNav />
        <Outlet />
      </div>
    </PageMotion>
  );
}
